import { IFrontHeaderTopLayoutProps } from '@framework/theme/src/front/FrontHeaderTopLayout';
import { ContentLayoutWrapper, FlexRow } from '@framework/ui';
import { Col, Layout, Row } from 'antd';
import clx from 'classnames';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { FrontHeaderLogo } from './header/FrontHeaderLogo';
const { Header } = Layout;

const StyledHeader = styled(Header)`
  &&& {
    width: 100%;
    padding: 0 16px;
    z-index: 11;
    height: auto;
    line-height: unset;

    background-color: ${props => props.theme.colorPrimary};
    color: #fff;

    &.boxed {
      padding: 0;
    }
  }
`;

const RowNoWrap = styled(Row)`
  flex-wrap: nowrap;
  /* height: ${props => props.theme.layoutHeaderContentHeight}px; */
  max-width: 100%;
  &.boxed {
    padding: 16px 24px;
    ${down('md')} {
      padding: 0 12px;
      min-height: 40px;
    }
    /* ${down('sm')} {
      padding: 0 12px;
      min-height: 40px;
    } */
  }
`;
const ColFixed = styled(Col)`
  flex: 0 0 auto;
  min-width: 0;
`;

const ColAuto = styled(Col)`
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  justify-content: end;
`;

const MenuBar = styled.div`
  padding: 0 24px;
  ${down('sm')} {
    padding: 0 12px;
  }
  .main-menu-wrapper-space {
    .ant-space-item {
      position: relative;
    }
  }

  // Stili per i link del menu principale
  a {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    line-height: ${props => props.theme.lineHeight};
    line-height: 54px;
    border-bottom: 1px solid transparent;
    border-radius: 1px;
    transition: border-bottom-color 0.2s ease-in-out;

    &:hover {
      border-bottom-color: #fff;
    }

    &:focus-visible {
      outline: 2px solid ${props => props.theme.focusOutlineNegativeColor};
      outline-offset: 3px;
    }
    &::after {
      content: '';
      display: block;
      height: 4px;
      background-color: transparent;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      transition: all 0.8s ease-in-out;
    }

    &.active {
      &::after {
        background-color: white;
      }
      &:hover {
        border-bottom-color: transparent;
      }
    }
  }
`;

const WhiteLine = styled.div`
  background-color: #fff;
  min-width: 0;
  width: 100%;
  height: 1px;
`;

const HeaderTitle = styled.div`
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  min-width: 0;
  padding-left: 24px;
  ${down('sm')} {
    padding-left: 12px;
    font-size: 15px;
  }
`;

/**
 * Fascia in alto della pagina che contiene il logo,
 * il menu principale, il menu delle notifiche e quello dell'utente.
 */
export function FrontHeaderTopLayout(props: IFrontHeaderTopLayoutProps) {
  const { boxed = true, main, right, title, minimal, onLogoClick } = props;

  return (
    <StyledHeader className={clx({ boxed })}>
      <ContentLayoutWrapper boxed={boxed}>
        <RowNoWrap align="middle" className={clx({ boxed })}>
          <FrontHeaderLogo onClick={onLogoClick} />
          {title && <HeaderTitle>{title}</HeaderTitle>}
          <ColAuto></ColAuto>
          <ColFixed>{right}</ColFixed>
        </RowNoWrap>
      </ContentLayoutWrapper>
      {!minimal && (
        <>
          <WhiteLine />
          <ContentLayoutWrapper boxed={boxed}>
            <MenuBar>
              <FlexRow>{main}</FlexRow>
            </MenuBar>
          </ContentLayoutWrapper>
        </>
      )}
    </StyledHeader>
  );
}
